import startQuizbtn from './../svg/startQuizbtn.svg';

export function GetSVGImport(name) {
    switch (name) {
        case "startQuizbtn.svg":
            return startQuizbtn
        default:
            throw new Error("Did not find imported SVG in svg-imports.js for " + name)
    }
}